import { render, staticRenderFns } from "./putLinkWd.vue?vue&type=template&id=1c981794&scoped=true"
import script from "./putLinkWd.vue?vue&type=script&lang=js"
export * from "./putLinkWd.vue?vue&type=script&lang=js"
import style0 from "./putLinkWd.vue?vue&type=style&index=0&id=1c981794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c981794",
  null
  
)

export default component.exports